import { inject, Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";

import { AWSAuthService } from "@intocare/aws";

@Injectable()
export class ConfirmPasswordGuard implements CanActivate {
	private authService = inject(AWSAuthService);
	private router = inject(Router);

	canActivate() {
		if (!this.authService.getUser()) {
			return this.router.createUrlTree([""]);
		}

		return true;
	}
}
